export class MailSetting{
    id:number;
    name:string;
    urlAddress:string;
    mail:string;
    password:string;
    smtp:string;
    port:number;

}